import { Label } from "@components";
import styles from "@styles/CashbackProgram.module.scss";

import classNames from "classnames/bind";
import { If } from "shared/components/control-statements";
import { Icon } from "shared/components/core/Icon";
const css = classNames.bind(styles);

export const TypeStep = ({ cashbackProgram, programLabels, onChange, showPoints }) => {

  const buildTypeLabels = () => {
    const labels = {
      CASHBACK: {
        singular: "cashback",
        plural: "cashback",
      },
      POINT: {
        singular: "ponto",
        plural: "pontos",
      },
    };

    for (const type in labels) {
      labels[type].singular = programLabels?.[type]?.singular || labels[type].singular;
      labels[type].plural = programLabels?.[type]?.plural || labels[type].plural;
    }

    return labels;
  };

  const typeLabels = buildTypeLabels();

  return (
    <>
      <Label text={"Determine o tipo"} className={"mb-20"} />
      <div className={styles.options}>
        <div
          className={css({
            option: true,
            active:
              !cashbackProgram?.type || cashbackProgram?.type === "CASHBACK",
          })}
          onClick={() =>
            onChange({
              ...cashbackProgram,
              type: "CASHBACK",
            })
          }
        >
          <If
            cond={
              !cashbackProgram?.type || cashbackProgram?.type !== "CASHBACK"
            }
          >
            <Icon name="hand-holding-dollar" light />
          </If>
          <If cond={cashbackProgram?.type === "CASHBACK"}>
            <Icon name="check" />
          </If>
          <p>{typeLabels?.CASHBACK?.plural}</p>
        </div>

        <If cond={showPoints}>
          <div
            className={css({
              option: true,
              active: cashbackProgram?.type === "POINT",
            })}
            onClick={() =>
              onChange({
                ...cashbackProgram,
                type: "POINT",
              })
            }
          >
            <If cond={cashbackProgram?.type !== "POINT"}>
              <Icon name="circle-1" light />
            </If>
            <If cond={cashbackProgram?.type === "POINT"}>
              <Icon name="check" />
            </If>
            <p>{typeLabels?.POINT?.plural}</p>
          </div>
        </If>
      </div>
    </>
  );
};
